import styled from "styled-components";
import { CheckCircleIcon, Text } from "@ficatranquilo/contabilidade.com-ui";
import { passwordRequirements } from "@helpers/signUp";

const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 20px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`;

// A lista dos dois cadastros públicos: o check fica verde conforme a pessoa digita
export default function PasswordRequirements({ password }) {
  return (
    <List>
      {passwordRequirements(password).map((req) => (
        <Item key={req.label}>
          <CheckCircleIcon $color={req.valid ? "P800" : "N200"} />
          <Text $text={req.label} $variant="caption_medium" $color={req.valid ? "P800" : "N500"} />
        </Item>
      ))}
    </List>
  );
}
